// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"8c97ae5a","395":"e8dd6440","453":"bf49c725","469":"695d500f","963":"1ac653c9"}[chunkId] + ".chunk.js";
};